import { render, staticRenderFns } from "./ed-slider.vue?vue&type=template&id=3084cc2c&scoped=true&"
import script from "./ed-slider.ts?vue&type=script&lang=ts&"
export * from "./ed-slider.ts?vue&type=script&lang=ts&"
import style0 from "./ed-slider.scss?vue&type=style&index=0&id=3084cc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084cc2c",
  null
  
)

export default component.exports